var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar"},[(_vm.name)?_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_c('el-progress',{attrs:{"percentage":_vm.percentageValue,"color":_vm.colors,"status":_vm.statusValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }